import Repository from './Repository';
import {AxiosResponse} from "axios";
import { CautionaryProductTypeOptions } from '@/models/Cautionary/CautionaryProductTypeOptions';
import {CaffeinatedProductType} from "@/models/Cautionary/CaffeinatedProductType";
import {CautionaryFoodType} from "@/models/Cautionary/CautionaryFoodType";

const resource = '/cautionary';

export default {
  getCautionaryProductTypes(): Promise<AxiosResponse<CautionaryProductTypeOptions>> {
    return Repository.get<CautionaryProductTypeOptions>(
      `${resource}/GetCautionaryProductTypes`,
      { withCredentials: true }
    );
  },
  getEligibility(
    recipeId: number,
    cautionaryFoodType: CautionaryFoodType,
    caffeinatedProductType: CaffeinatedProductType,
    servingsPerContainer: number
  ): Promise<AxiosResponse<boolean>> {
    return Repository.get<boolean>(
      `${resource}/Eligibility/${recipeId}?cautionaryFoodType=${cautionaryFoodType}&productType=${caffeinatedProductType}&servingsPerContainer=${servingsPerContainer}`,
      { withCredentials: true }
    );
  }
};
